import * as yup from 'yup';

export const subjectCommentsSchema = yup.object().shape({
  subjectComment: yup
    .string()
    .max(4000, 'Polje "Komentar" mora imati manje od 4000 karaktera.'),

});
